import { render } from "./UploadCustomerList.vue?vue&type=template&id=18216a6e&scoped=true"
import script from "./UploadCustomerList.vue?vue&type=script&lang=js"
export * from "./UploadCustomerList.vue?vue&type=script&lang=js"

import "./UploadCustomerList.vue?vue&type=style&index=0&id=18216a6e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18216a6e"

export default script